import {NewsDto} from "../../../services/Client";

export const reorder = (list: NewsDto[], startIndex: number, endIndex: number): NewsDto[] => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};



// WEBPACK FOOTER //
// ./src/views/AdminView/NotesAndNewsTab/NotesAndNewsUtils.ts